export default () => (
  <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="qr-code 1" clipPath="url(#clip0_3_53971)">
      <g id="Group">
        <g id="Group_2">
          <g id="Group_3">
            <path id="Vector" d="M36.7564 0H34.5942V2.16216H36.7564V0Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_4">
          <g id="Group_5">
            <path id="Vector_2" d="M41.0806 0H38.9185V2.16216H41.0806V0Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_6">
          <g id="Group_7">
            <path id="Vector_3" d="M43.2437 0H41.0815V2.16216H43.2437V0Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_8">
          <g id="Group_9">
            <path id="Vector_4" d="M45.4083 0H43.2461V2.16216H45.4083V0Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_10">
          <g id="Group_11">
            <path id="Vector_5" d="M47.5679 0H45.4058V2.16216H47.5679V0Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_12">
          <g id="Group_13">
            <path id="Vector_6" d="M51.8897 0H49.7275V2.16216H51.8897V0Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_14">
          <g id="Group_15">
            <path id="Vector_7" d="M56.2164 0H54.0542V2.16216H56.2164V0Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_16">
          <g id="Group_17">
            <path id="Vector_8" d="M62.7039 0H60.5417V2.16216H62.7039V0Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_18">
          <g id="Group_19">
            <path id="Vector_9" d="M23.7828 2.16174H21.6206V4.32391H23.7828V2.16174Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_20">
          <g id="Group_21">
            <path id="Vector_10" d="M30.2698 2.16223H28.1077V4.32439H30.2698V2.16223Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_22">
          <g id="Group_23">
            <path id="Vector_11" d="M32.4346 2.16174H30.2725V4.32391H32.4346V2.16174Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_24">
          <g id="Group_25">
            <path id="Vector_12" d="M38.9161 2.16174H36.7539V4.32391H38.9161V2.16174Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_26">
          <g id="Group_27">
            <path id="Vector_13" d="M41.0806 2.16223H38.9185V4.32439H41.0806V2.16223Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_28">
          <g id="Group_29">
            <path id="Vector_14" d="M54.0545 2.16223H51.8923V4.32439H54.0545V2.16223Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_30">
          <g id="Group_31">
            <path id="Vector_15" d="M56.2164 2.16223H54.0542V4.32439H56.2164V2.16223Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_32">
          <g id="Group_33">
            <path id="Vector_16" d="M58.377 2.16174H56.2148V4.32391H58.377V2.16174Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_34">
          <g id="Group_35">
            <path id="Vector_17" d="M60.5416 2.16174H58.3794V4.32391H60.5416V2.16174Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_36">
          <g id="Group_37">
            <path id="Vector_18" d="M19.4605 4.32483H17.2983V6.48698H19.4605V4.32483Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_38">
          <g id="Group_39">
            <path id="Vector_19" d="M23.7828 4.32483H21.6206V6.48698H23.7828V4.32483Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_40">
          <g id="Group_41">
            <path id="Vector_20" d="M32.4346 4.32483H30.2725V6.48698H32.4346V4.32483Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_42">
          <g id="Group_43">
            <path id="Vector_21" d="M43.2437 4.32428H41.0815V6.48643H43.2437V4.32428Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_44">
          <g id="Group_45">
            <path id="Vector_22" d="M45.4083 4.32483H43.2461V6.48698H45.4083V4.32483Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_46">
          <g id="Group_47">
            <path id="Vector_23" d="M47.5679 4.32428H45.4058V6.48643H47.5679V4.32428Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_48">
          <g id="Group_49">
            <path id="Vector_24" d="M49.7295 4.32428H47.5674V6.48643H49.7295V4.32428Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_50">
          <g id="Group_51">
            <path id="Vector_25" d="M51.8897 4.32483H49.7275V6.48698H51.8897V4.32483Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_52">
          <g id="Group_53">
            <path id="Vector_26" d="M58.377 4.32483H56.2148V6.48698H58.377V4.32483Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_54">
          <g id="Group_55">
            <path id="Vector_27" d="M62.7039 4.32428H60.5417V6.48643H62.7039V4.32428Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_56">
          <g id="Group_57">
            <path id="Vector_28" d="M19.4605 6.48657H17.2983V8.64873H19.4605V6.48657Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_58">
          <g id="Group_59">
            <path id="Vector_29" d="M23.7828 6.48657H21.6206V8.64873H23.7828V6.48657Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_60">
          <g id="Group_61">
            <path id="Vector_30" d="M28.108 6.48645H25.9458V8.64861H28.108V6.48645Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_62">
          <g id="Group_63">
            <path id="Vector_31" d="M30.2698 6.48645H28.1077V8.64861H30.2698V6.48645Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_64">
          <g id="Group_65">
            <path id="Vector_32" d="M32.4346 6.48657H30.2725V8.64873H32.4346V6.48657Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_66">
          <g id="Group_67">
            <path id="Vector_33" d="M34.5948 6.48645H32.4326V8.64861H34.5948V6.48645Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_68">
          <g id="Group_69">
            <path id="Vector_34" d="M38.9161 6.48657H36.7539V8.64873H38.9161V6.48657Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_70">
          <g id="Group_71">
            <path id="Vector_35" d="M41.0806 6.48645H38.9185V8.64861H41.0806V6.48645Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_72">
          <g id="Group_73">
            <path id="Vector_36" d="M45.4083 6.48657H43.2461V8.64873H45.4083V6.48657Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_74">
          <g id="Group_75">
            <path id="Vector_37" d="M49.7295 6.48645H47.5674V8.64861H49.7295V6.48645Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_76">
          <g id="Group_77">
            <path id="Vector_38" d="M51.8897 6.48657H49.7275V8.64873H51.8897V6.48657Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_78">
          <g id="Group_79">
            <path id="Vector_39" d="M56.2164 6.48645H54.0542V8.64861H56.2164V6.48645Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_80">
          <g id="Group_81">
            <path id="Vector_40" d="M58.377 6.48657H56.2148V8.64873H58.377V6.48657Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_82">
          <g id="Group_83">
            <path id="Vector_41" d="M19.4605 8.6485H17.2983V10.8107H19.4605V8.6485Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_84">
          <g id="Group_85">
            <path id="Vector_42" d="M21.6204 8.64874H19.4583V10.8109H21.6204V8.64874Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_86">
          <g id="Group_87">
            <path id="Vector_43" d="M28.108 8.64874H25.9458V10.8109H28.108V8.64874Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_88">
          <g id="Group_89">
            <path id="Vector_44" d="M36.7564 8.64874H34.5942V10.8109H36.7564V8.64874Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_90">
          <g id="Group_91">
            <path id="Vector_45" d="M38.9161 8.6485H36.7539V10.8107H38.9161V8.6485Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_92">
          <g id="Group_93">
            <path id="Vector_46" d="M41.0806 8.64874H38.9185V10.8109H41.0806V8.64874Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_94">
          <g id="Group_95">
            <path id="Vector_47" d="M43.2437 8.64874H41.0815V10.8109H43.2437V8.64874Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_96">
          <g id="Group_97">
            <path id="Vector_48" d="M45.4083 8.6485H43.2461V10.8107H45.4083V8.6485Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_98">
          <g id="Group_99">
            <path id="Vector_49" d="M49.7295 8.64874H47.5674V10.8109H49.7295V8.64874Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_100">
          <g id="Group_101">
            <path id="Vector_50" d="M51.8897 8.6485H49.7275V10.8107H51.8897V8.6485Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_102">
          <g id="Group_103">
            <path id="Vector_51" d="M62.7039 8.64874H60.5417V10.8109H62.7039V8.64874Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_104">
          <g id="Group_105">
            <path id="Vector_52" d="M19.4605 10.8114H17.2983V12.9736H19.4605V10.8114Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_106">
          <g id="Group_107">
            <path id="Vector_53" d="M21.6204 10.8109H19.4583V12.9731H21.6204V10.8109Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_108">
          <g id="Group_109">
            <path id="Vector_54" d="M23.7828 10.8114H21.6206V12.9736H23.7828V10.8114Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_110">
          <g id="Group_111">
            <path id="Vector_55" d="M28.108 10.8109H25.9458V12.9731H28.108V10.8109Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_112">
          <g id="Group_113">
            <path id="Vector_56" d="M32.4346 10.8114H30.2725V12.9736H32.4346V10.8114Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_114">
          <g id="Group_115">
            <path id="Vector_57" d="M41.0806 10.8109H38.9185V12.9731H41.0806V10.8109Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_116">
          <g id="Group_117">
            <path id="Vector_58" d="M58.377 10.8114H56.2148V12.9736H58.377V10.8114Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_118">
          <g id="Group_119">
            <path id="Vector_59" d="M60.5416 10.8114H58.3794V12.9736H60.5416V10.8114Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_120">
          <g id="Group_121">
            <path id="Vector_60" d="M62.7039 10.8109H60.5417V12.9731H62.7039V10.8109Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_122">
          <g id="Group_123">
            <path id="Vector_61" d="M19.4605 12.9731H17.2983V15.1353H19.4605V12.9731Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_124">
          <g id="Group_125">
            <path id="Vector_62" d="M23.7828 12.9731H21.6206V15.1353H23.7828V12.9731Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_126">
          <g id="Group_127">
            <path id="Vector_63" d="M28.108 12.973H25.9458V15.1351H28.108V12.973Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_128">
          <g id="Group_129">
            <path id="Vector_64" d="M32.4346 12.9731H30.2725V15.1353H32.4346V12.9731Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_130">
          <g id="Group_131">
            <path id="Vector_65" d="M36.7564 12.973H34.5942V15.1351H36.7564V12.973Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_132">
          <g id="Group_133">
            <path id="Vector_66" d="M41.0806 12.973H38.9185V15.1351H41.0806V12.973Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_134">
          <g id="Group_135">
            <path id="Vector_67" d="M45.4083 12.9731H43.2461V15.1353H45.4083V12.9731Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_136">
          <g id="Group_137">
            <path id="Vector_68" d="M49.7295 12.973H47.5674V15.1351H49.7295V12.973Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_138">
          <g id="Group_139">
            <path id="Vector_69" d="M54.0545 12.973H51.8923V15.1351H54.0545V12.973Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_140">
          <g id="Group_141">
            <path id="Vector_70" d="M58.377 12.9731H56.2148V15.1353H58.377V12.9731Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_142">
          <g id="Group_143">
            <path id="Vector_71" d="M62.7039 12.973H60.5417V15.1351H62.7039V12.973Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_144">
          <g id="Group_145">
            <path id="Vector_72" d="M19.4605 15.1351H17.2983V17.2972H19.4605V15.1351Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_146">
          <g id="Group_147">
            <path id="Vector_73" d="M23.7828 15.1351H21.6206V17.2972H23.7828V15.1351Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_148">
          <g id="Group_149">
            <path id="Vector_74" d="M25.9473 15.1351H23.7852V17.2972H25.9473V15.1351Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_150">
          <g id="Group_151">
            <path id="Vector_75" d="M28.108 15.1352H25.9458V17.2974H28.108V15.1352Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_152">
          <g id="Group_153">
            <path id="Vector_76" d="M30.2698 15.1352H28.1077V17.2974H30.2698V15.1352Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_154">
          <g id="Group_155">
            <path id="Vector_77" d="M32.4346 15.1351H30.2725V17.2972H32.4346V15.1351Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_156">
          <g id="Group_157">
            <path id="Vector_78" d="M36.7564 15.1352H34.5942V17.2974H36.7564V15.1352Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_158">
          <g id="Group_159">
            <path id="Vector_79" d="M41.0806 15.1352H38.9185V17.2974H41.0806V15.1352Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_160">
          <g id="Group_161">
            <path id="Vector_80" d="M47.5679 15.1352H45.4058V17.2974H47.5679V15.1352Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_162">
          <g id="Group_163">
            <path id="Vector_81" d="M49.7295 15.1352H47.5674V17.2974H49.7295V15.1352Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_164">
          <g id="Group_165">
            <path id="Vector_82" d="M51.8897 15.1351H49.7275V17.2972H51.8897V15.1351Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_166">
          <g id="Group_167">
            <path id="Vector_83" d="M62.7039 15.1352H60.5417V17.2974H62.7039V15.1352Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_168">
          <g id="Group_169">
            <path id="Vector_84" d="M2.16216 17.2974H0V19.4596H2.16216V17.2974Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_170">
          <g id="Group_171">
            <path id="Vector_85" d="M6.48735 17.2979H4.3252V19.4601H6.48735V17.2979Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_172">
          <g id="Group_173">
            <path id="Vector_86" d="M8.64727 17.2974H6.48511V19.4596H8.64727V17.2974Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_174">
          <g id="Group_175">
            <path id="Vector_87" d="M10.8101 17.2979H8.64795V19.4601H10.8101V17.2979Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_176">
          <g id="Group_177">
            <path id="Vector_88" d="M12.9695 17.2979H10.8074V19.4601H12.9695V17.2979Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_178">
          <g id="Group_179">
            <path id="Vector_89" d="M15.1346 17.2974H12.9724V19.4596H15.1346V17.2974Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_180">
          <g id="Group_181">
            <path id="Vector_90" d="M21.6204 17.2974H19.4583V19.4596H21.6204V17.2974Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_182">
          <g id="Group_183">
            <path id="Vector_91" d="M23.7828 17.2979H21.6206V19.4601H23.7828V17.2979Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_184">
          <g id="Group_185">
            <path id="Vector_92" d="M25.9473 17.2979H23.7852V19.4601H25.9473V17.2979Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_186">
          <g id="Group_187">
            <path id="Vector_93" d="M30.2698 17.2974H28.1077V19.4596H30.2698V17.2974Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_188">
          <g id="Group_189">
            <path id="Vector_94" d="M34.5948 17.2974H32.4326V19.4596H34.5948V17.2974Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_190">
          <g id="Group_191">
            <path id="Vector_95" d="M38.9161 17.2979H36.7539V19.4601H38.9161V17.2979Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_192">
          <g id="Group_193">
            <path id="Vector_96" d="M49.7295 17.2974H47.5674V19.4596H49.7295V17.2974Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_194">
          <g id="Group_195">
            <path id="Vector_97" d="M51.8897 17.2979H49.7275V19.4601H51.8897V17.2979Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_196">
          <g id="Group_197">
            <path id="Vector_98" d="M54.0545 17.2974H51.8923V19.4596H54.0545V17.2974Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_198">
          <g id="Group_199">
            <path id="Vector_99" d="M56.2164 17.2974H54.0542V19.4596H56.2164V17.2974Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_200">
          <g id="Group_201">
            <path id="Vector_100" d="M58.377 17.2979H56.2148V19.4601H58.377V17.2979Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_202">
          <g id="Group_203">
            <path id="Vector_101" d="M67.0281 17.2974H64.866V19.4596H67.0281V17.2974Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_204">
          <g id="Group_205">
            <path id="Vector_102" d="M69.1898 17.2974H67.0276V19.4596H69.1898V17.2974Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_206">
          <g id="Group_207">
            <path id="Vector_103" d="M71.3548 17.2979H69.1926V19.4601H71.3548V17.2979Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_208">
          <g id="Group_209">
            <path id="Vector_104" d="M73.5142 17.2979H71.3521V19.4601H73.5142V17.2979Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_210">
          <g id="Group_211">
            <path id="Vector_105" d="M75.6771 17.2974H73.5149V19.4596H75.6771V17.2974Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_212">
          <g id="Group_213">
            <path id="Vector_106" d="M2.16216 19.4597H0V21.6218H2.16216V19.4597Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_214">
          <g id="Group_215">
            <path id="Vector_107" d="M4.32354 19.4597H2.16138V21.6218H4.32354V19.4597Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_216">
          <g id="Group_217">
            <path id="Vector_108" d="M6.48735 19.4599H4.3252V21.6221H6.48735V19.4599Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_218">
          <g id="Group_219">
            <path id="Vector_109" d="M8.64727 19.4597H6.48511V21.6218H8.64727V19.4597Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_220">
          <g id="Group_221">
            <path id="Vector_110" d="M10.8101 19.4599H8.64795V21.6221H10.8101V19.4599Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_222">
          <g id="Group_223">
            <path id="Vector_111" d="M12.9695 19.4599H10.8074V21.6221H12.9695V19.4599Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_224">
          <g id="Group_225">
            <path id="Vector_112" d="M17.2962 19.4597H15.134V21.6218H17.2962V19.4597Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_226">
          <g id="Group_227">
            <path id="Vector_113" d="M25.9473 19.4599H23.7852V21.6221H25.9473V19.4599Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_228">
          <g id="Group_229">
            <path id="Vector_114" d="M28.108 19.4597H25.9458V21.6218H28.108V19.4597Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_230">
          <g id="Group_231">
            <path id="Vector_115" d="M30.2698 19.4597H28.1077V21.6218H30.2698V19.4597Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_232">
          <g id="Group_233">
            <path id="Vector_116" d="M32.4346 19.4599H30.2725V21.6221H32.4346V19.4599Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_234">
          <g id="Group_235">
            <path id="Vector_117" d="M34.5948 19.4597H32.4326V21.6218H34.5948V19.4597Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_236">
          <g id="Group_237">
            <path id="Vector_118" d="M36.7564 19.4597H34.5942V21.6218H36.7564V19.4597Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_238">
          <g id="Group_239">
            <path id="Vector_119" d="M38.9161 19.4599H36.7539V21.6221H38.9161V19.4599Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_240">
          <g id="Group_241">
            <path id="Vector_120" d="M41.0806 19.4597H38.9185V21.6218H41.0806V19.4597Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_242">
          <g id="Group_243">
            <path id="Vector_121" d="M43.2437 19.4597H41.0815V21.6218H43.2437V19.4597Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_244">
          <g id="Group_245">
            <path id="Vector_122" d="M47.5679 19.4597H45.4058V21.6218H47.5679V19.4597Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_246">
          <g id="Group_247">
            <path id="Vector_123" d="M49.7295 19.4597H47.5674V21.6218H49.7295V19.4597Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_248">
          <g id="Group_249">
            <path id="Vector_124" d="M51.8897 19.4599H49.7275V21.6221H51.8897V19.4599Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_250">
          <g id="Group_251">
            <path id="Vector_125" d="M58.377 19.4599H56.2148V21.6221H58.377V19.4599Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_252">
          <g id="Group_253">
            <path id="Vector_126" d="M62.7039 19.4597H60.5417V21.6218H62.7039V19.4597Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_254">
          <g id="Group_255">
            <path id="Vector_127" d="M69.1898 19.4597H67.0276V21.6218H69.1898V19.4597Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_256">
          <g id="Group_257">
            <path id="Vector_128" d="M77.8369 19.4599H75.6748V21.6221H77.8369V19.4599Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_258">
          <g id="Group_259">
            <path id="Vector_129" d="M2.16216 21.6215H0V23.7836H2.16216V21.6215Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_260">
          <g id="Group_261">
            <path id="Vector_130" d="M15.1346 21.6215H12.9724V23.7836H15.1346V21.6215Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_262">
          <g id="Group_263">
            <path id="Vector_131" d="M17.2962 21.6215H15.134V23.7836H17.2962V21.6215Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_264">
          <g id="Group_265">
            <path id="Vector_132" d="M19.4605 21.6216H17.2983V23.7838H19.4605V21.6216Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_266">
          <g id="Group_267">
            <path id="Vector_133" d="M21.6204 21.6215H19.4583V23.7836H21.6204V21.6215Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_268">
          <g id="Group_269">
            <path id="Vector_134" d="M25.9473 21.6216H23.7852V23.7838H25.9473V21.6216Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_270">
          <g id="Group_271">
            <path id="Vector_135" d="M30.2698 21.6215H28.1077V23.7836H30.2698V21.6215Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_272">
          <g id="Group_273">
            <path id="Vector_136" d="M32.4346 21.6216H30.2725V23.7838H32.4346V21.6216Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_274">
          <g id="Group_275">
            <path id="Vector_137" d="M38.9161 21.6216H36.7539V23.7838H38.9161V21.6216Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_276">
          <g id="Group_277">
            <path id="Vector_138" d="M47.5679 21.6215H45.4058V23.7836H47.5679V21.6215Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_278">
          <g id="Group_279">
            <path id="Vector_139" d="M49.7295 21.6215H47.5674V23.7836H49.7295V21.6215Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_280">
          <g id="Group_281">
            <path id="Vector_140" d="M56.2164 21.6215H54.0542V23.7836H56.2164V21.6215Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_282">
          <g id="Group_283">
            <path id="Vector_141" d="M58.377 21.6216H56.2148V23.7838H58.377V21.6216Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_284">
          <g id="Group_285">
            <path id="Vector_142" d="M60.5416 21.6216H58.3794V23.7838H60.5416V21.6216Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_286">
          <g id="Group_287">
            <path id="Vector_143" d="M62.7039 21.6215H60.5417V23.7836H62.7039V21.6215Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_288">
          <g id="Group_289">
            <path id="Vector_144" d="M67.0281 21.6215H64.866V23.7836H67.0281V21.6215Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_290">
          <g id="Group_291">
            <path id="Vector_145" d="M71.3548 21.6216H69.1926V23.7838H71.3548V21.6216Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_292">
          <g id="Group_293">
            <path id="Vector_146" d="M73.5142 21.6216H71.3521V23.7838H73.5142V21.6216Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_294">
          <g id="Group_295">
            <path id="Vector_147" d="M77.8369 21.6216H75.6748V23.7838H77.8369V21.6216Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_296">
          <g id="Group_297">
            <path id="Vector_148" d="M80.0008 21.6215H77.8386V23.7836H80.0008V21.6215Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_298">
          <g id="Group_299">
            <path id="Vector_149" d="M2.16216 23.7837H0V25.9459H2.16216V23.7837Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_300">
          <g id="Group_301">
            <path id="Vector_150" d="M17.2962 23.7837H15.134V25.9459H17.2962V23.7837Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_302">
          <g id="Group_303">
            <path id="Vector_151" d="M19.4605 23.7834H17.2983V25.9456H19.4605V23.7834Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_304">
          <g id="Group_305">
            <path id="Vector_152" d="M25.9473 23.7834H23.7852V25.9456H25.9473V23.7834Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_306">
          <g id="Group_307">
            <path id="Vector_153" d="M36.7564 23.7837H34.5942V25.9459H36.7564V23.7837Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_308">
          <g id="Group_309">
            <path id="Vector_154" d="M45.4083 23.7834H43.2461V25.9456H45.4083V23.7834Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_310">
          <g id="Group_311">
            <path id="Vector_155" d="M47.5679 23.7837H45.4058V25.9459H47.5679V23.7837Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_312">
          <g id="Group_313">
            <path id="Vector_156" d="M54.0545 23.7837H51.8923V25.9459H54.0545V23.7837Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_314">
          <g id="Group_315">
            <path id="Vector_157" d="M58.377 23.7834H56.2148V25.9456H58.377V23.7834Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_316">
          <g id="Group_317">
            <path id="Vector_158" d="M60.5416 23.7834H58.3794V25.9456H60.5416V23.7834Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_318">
          <g id="Group_319">
            <path id="Vector_159" d="M67.0281 23.7837H64.866V25.9459H67.0281V23.7837Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_320">
          <g id="Group_321">
            <path id="Vector_160" d="M73.5142 23.7834H71.3521V25.9456H73.5142V23.7834Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_322">
          <g id="Group_323">
            <path id="Vector_161" d="M80.0008 23.7837H77.8386V25.9459H80.0008V23.7837Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_324">
          <g id="Group_325">
            <path id="Vector_162" d="M2.16216 25.9459H0V28.1081H2.16216V25.9459Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_326">
          <g id="Group_327">
            <path id="Vector_163" d="M4.32354 25.9459H2.16138V28.1081H4.32354V25.9459Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_328">
          <g id="Group_329">
            <path id="Vector_164" d="M8.64727 25.9459H6.48511V28.1081H8.64727V25.9459Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_330">
          <g id="Group_331">
            <path id="Vector_165" d="M12.9695 25.9464H10.8074V28.1086H12.9695V25.9464Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_332">
          <g id="Group_333">
            <path id="Vector_166" d="M15.1346 25.9459H12.9724V28.1081H15.1346V25.9459Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_334">
          <g id="Group_335">
            <path id="Vector_167" d="M17.2962 25.9459H15.134V28.1081H17.2962V25.9459Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_336">
          <g id="Group_337">
            <path id="Vector_168" d="M19.4605 25.9464H17.2983V28.1086H19.4605V25.9464Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_338">
          <g id="Group_339">
            <path id="Vector_169" d="M25.9473 25.9464H23.7852V28.1086H25.9473V25.9464Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_340">
          <g id="Group_341">
            <path id="Vector_170" d="M28.108 25.9459H25.9458V28.1081H28.108V25.9459Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_342">
          <g id="Group_343">
            <path id="Vector_171" d="M30.2698 25.9459H28.1077V28.1081H30.2698V25.9459Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_344">
          <g id="Group_345">
            <path id="Vector_172" d="M36.7564 25.9459H34.5942V28.1081H36.7564V25.9459Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_346">
          <g id="Group_347">
            <path id="Vector_173" d="M38.9161 25.9464H36.7539V28.1086H38.9161V25.9464Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_348">
          <g id="Group_349">
            <path id="Vector_174" d="M45.4083 25.9464H43.2461V28.1086H45.4083V25.9464Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_350">
          <g id="Group_351">
            <path id="Vector_175" d="M49.7295 25.9459H47.5674V28.1081H49.7295V25.9459Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_352">
          <g id="Group_353">
            <path id="Vector_176" d="M54.0545 25.9459H51.8923V28.1081H54.0545V25.9459Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_354">
          <g id="Group_355">
            <path id="Vector_177" d="M56.2164 25.9459H54.0542V28.1081H56.2164V25.9459Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_356">
          <g id="Group_357">
            <path id="Vector_178" d="M58.377 25.9464H56.2148V28.1086H58.377V25.9464Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_358">
          <g id="Group_359">
            <path id="Vector_179" d="M60.5416 25.9464H58.3794V28.1086H60.5416V25.9464Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_360">
          <g id="Group_361">
            <path id="Vector_180" d="M64.8638 25.9464H62.7017V28.1086H64.8638V25.9464Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_362">
          <g id="Group_363">
            <path id="Vector_181" d="M67.0281 25.9459H64.866V28.1081H67.0281V25.9459Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_364">
          <g id="Group_365">
            <path id="Vector_182" d="M69.1898 25.9459H67.0276V28.1081H69.1898V25.9459Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_366">
          <g id="Group_367">
            <path id="Vector_183" d="M71.3548 25.9464H69.1926V28.1086H71.3548V25.9464Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_368">
          <g id="Group_369">
            <path id="Vector_184" d="M75.6771 25.9459H73.5149V28.1081H75.6771V25.9459Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_370">
          <g id="Group_371">
            <path id="Vector_185" d="M77.8369 25.9464H75.6748V28.1086H77.8369V25.9464Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_372">
          <g id="Group_373">
            <path id="Vector_186" d="M80.0008 25.9459H77.8386V28.1081H80.0008V25.9459Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_374">
          <g id="Group_375">
            <path id="Vector_187" d="M2.16216 28.108H0V30.2701H2.16216V28.108Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_376">
          <g id="Group_377">
            <path id="Vector_188" d="M4.32354 28.108H2.16138V30.2701H4.32354V28.108Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_378">
          <g id="Group_379">
            <path id="Vector_189" d="M10.8101 28.1082H8.64795V30.2704H10.8101V28.1082Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_380">
          <g id="Group_381">
            <path id="Vector_190" d="M12.9695 28.1082H10.8074V30.2704H12.9695V28.1082Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_382">
          <g id="Group_383">
            <path id="Vector_191" d="M17.2962 28.108H15.134V30.2701H17.2962V28.108Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_384">
          <g id="Group_385">
            <path id="Vector_192" d="M19.4605 28.1082H17.2983V30.2704H19.4605V28.1082Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_386">
          <g id="Group_387">
            <path id="Vector_193" d="M21.6204 28.108H19.4583V30.2701H21.6204V28.108Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_388">
          <g id="Group_389">
            <path id="Vector_194" d="M28.108 28.108H25.9458V30.2701H28.108V28.108Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_390">
          <g id="Group_391">
            <path id="Vector_195" d="M30.2698 28.108H28.1077V30.2701H30.2698V28.108Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_392">
          <g id="Group_393">
            <path id="Vector_196" d="M36.7564 28.108H34.5942V30.2701H36.7564V28.108Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_394">
          <g id="Group_395">
            <path id="Vector_197" d="M38.9161 28.1082H36.7539V30.2704H38.9161V28.1082Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_396">
          <g id="Group_397">
            <path id="Vector_198" d="M41.0806 28.108H38.9185V30.2701H41.0806V28.108Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_398">
          <g id="Group_399">
            <path id="Vector_199" d="M43.2437 28.108H41.0815V30.2701H43.2437V28.108Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_400">
          <g id="Group_401">
            <path id="Vector_200" d="M45.4083 28.1082H43.2461V30.2704H45.4083V28.1082Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_402">
          <g id="Group_403">
            <path id="Vector_201" d="M47.5679 28.108H45.4058V30.2701H47.5679V28.108Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_404">
          <g id="Group_405">
            <path id="Vector_202" d="M51.8897 28.1082H49.7275V30.2704H51.8897V28.1082Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_406">
          <g id="Group_407">
            <path id="Vector_203" d="M54.0545 28.108H51.8923V30.2701H54.0545V28.108Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_408">
          <g id="Group_409">
            <path id="Vector_204" d="M62.7039 28.108H60.5417V30.2701H62.7039V28.108Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_410">
          <g id="Group_411">
            <path id="Vector_205" d="M69.1898 28.108H67.0276V30.2701H69.1898V28.108Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_412">
          <g id="Group_413">
            <path id="Vector_206" d="M2.16216 30.2702H0V32.4324H2.16216V30.2702Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_414">
          <g id="Group_415">
            <path id="Vector_207" d="M4.32354 30.2702H2.16138V32.4324H4.32354V30.2702Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_416">
          <g id="Group_417">
            <path id="Vector_208" d="M6.48735 30.2701H4.3252V32.4323H6.48735V30.2701Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_418">
          <g id="Group_419">
            <path id="Vector_209" d="M8.64727 30.2702H6.48511V32.4324H8.64727V30.2702Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_420">
          <g id="Group_421">
            <path id="Vector_210" d="M10.8101 30.2701H8.64795V32.4323H10.8101V30.2701Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_422">
          <g id="Group_423">
            <path id="Vector_211" d="M15.1346 30.2702H12.9724V32.4324H15.1346V30.2702Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_424">
          <g id="Group_425">
            <path id="Vector_212" d="M23.7828 30.2701H21.6206V32.4323H23.7828V30.2701Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_426">
          <g id="Group_427">
            <path id="Vector_213" d="M30.2698 30.2702H28.1077V32.4324H30.2698V30.2702Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_428">
          <g id="Group_429">
            <path id="Vector_214" d="M34.5948 30.2702H32.4326V32.4324H34.5948V30.2702Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_430">
          <g id="Group_431">
            <path id="Vector_215" d="M47.5679 30.2702H45.4058V32.4324H47.5679V30.2702Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_432">
          <g id="Group_433">
            <path id="Vector_216" d="M56.2164 30.2702H54.0542V32.4324H56.2164V30.2702Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_434">
          <g id="Group_435">
            <path id="Vector_217" d="M60.5416 30.2701H58.3794V32.4323H60.5416V30.2701Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_436">
          <g id="Group_437">
            <path id="Vector_218" d="M62.7039 30.2702H60.5417V32.4324H62.7039V30.2702Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_438">
          <g id="Group_439">
            <path id="Vector_219" d="M67.0281 30.2702H64.866V32.4324H67.0281V30.2702Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_440">
          <g id="Group_441">
            <path id="Vector_220" d="M69.1898 30.2702H67.0276V32.4324H69.1898V30.2702Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_442">
          <g id="Group_443">
            <path id="Vector_221" d="M71.3548 30.2701H69.1926V32.4323H71.3548V30.2701Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_444">
          <g id="Group_445">
            <path id="Vector_222" d="M73.5142 30.2701H71.3521V32.4323H73.5142V30.2701Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_446">
          <g id="Group_447">
            <path id="Vector_223" d="M77.8369 30.2701H75.6748V32.4323H77.8369V30.2701Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_448">
          <g id="Group_449">
            <path id="Vector_224" d="M80.0008 30.2702H77.8386V32.4324H80.0008V30.2702Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_450">
          <g id="Group_451">
            <path id="Vector_225" d="M8.64727 32.4324H6.48511V34.5946H8.64727V32.4324Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_452">
          <g id="Group_453">
            <path id="Vector_226" d="M12.9695 32.4319H10.8074V34.5941H12.9695V32.4319Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_454">
          <g id="Group_455">
            <path id="Vector_227" d="M19.4605 32.4319H17.2983V34.5941H19.4605V32.4319Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_456">
          <g id="Group_457">
            <path id="Vector_228" d="M21.6204 32.4324H19.4583V34.5946H21.6204V32.4324Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_458">
          <g id="Group_459">
            <path id="Vector_229" d="M23.7828 32.4319H21.6206V34.5941H23.7828V32.4319Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_460">
          <g id="Group_461">
            <path id="Vector_230" d="M25.9473 32.4319H23.7852V34.5941H25.9473V32.4319Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_462">
          <g id="Group_463">
            <path id="Vector_231" d="M28.108 32.4324H25.9458V34.5946H28.108V32.4324Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_464">
          <g id="Group_465">
            <path id="Vector_232" d="M30.2698 32.4324H28.1077V34.5946H30.2698V32.4324Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_466">
          <g id="Group_467">
            <path id="Vector_233" d="M34.5948 32.4324H32.4326V34.5946H34.5948V32.4324Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_468">
          <g id="Group_469">
            <path id="Vector_234" d="M36.7564 32.4324H34.5942V34.5946H36.7564V32.4324Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_470">
          <g id="Group_471">
            <path id="Vector_235" d="M41.0806 32.4324H38.9185V34.5946H41.0806V32.4324Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_472">
          <g id="Group_473">
            <path id="Vector_236" d="M47.5679 32.4324H45.4058V34.5946H47.5679V32.4324Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_474">
          <g id="Group_475">
            <path id="Vector_237" d="M62.7039 32.4324H60.5417V34.5946H62.7039V32.4324Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_476">
          <g id="Group_477">
            <path id="Vector_238" d="M64.8638 32.4319H62.7017V34.5941H64.8638V32.4319Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_478">
          <g id="Group_479">
            <path id="Vector_239" d="M67.0281 32.4324H64.866V34.5946H67.0281V32.4324Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_480">
          <g id="Group_481">
            <path id="Vector_240" d="M69.1898 32.4324H67.0276V34.5946H69.1898V32.4324Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_482">
          <g id="Group_483">
            <path id="Vector_241" d="M71.3548 32.4319H69.1926V34.5941H71.3548V32.4319Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_484">
          <g id="Group_485">
            <path id="Vector_242" d="M77.8369 32.4319H75.6748V34.5941H77.8369V32.4319Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_486">
          <g id="Group_487">
            <path id="Vector_243" d="M80.0008 32.4324H77.8386V34.5946H80.0008V32.4324Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_488">
          <g id="Group_489">
            <path id="Vector_244" d="M2.16216 34.5947H0V36.7568H2.16216V34.5947Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_490">
          <g id="Group_491">
            <path id="Vector_245" d="M6.48735 34.5948H4.3252V36.757H6.48735V34.5948Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_492">
          <g id="Group_493">
            <path id="Vector_246" d="M8.64727 34.5947H6.48511V36.7568H8.64727V34.5947Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_494">
          <g id="Group_495">
            <path id="Vector_247" d="M15.1346 34.5947H12.9724V36.7568H15.1346V34.5947Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_496">
          <g id="Group_497">
            <path id="Vector_248" d="M19.4605 34.5948H17.2983V36.757H19.4605V34.5948Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_498">
          <g id="Group_499">
            <path id="Vector_249" d="M28.108 34.5947H25.9458V36.7568H28.108V34.5947Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_500">
          <g id="Group_501">
            <path id="Vector_250" d="M32.4346 34.5948H30.2725V36.757H32.4346V34.5948Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_502">
          <g id="Group_503">
            <path id="Vector_251" d="M36.7564 34.5947H34.5942V36.7568H36.7564V34.5947Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_504">
          <g id="Group_505">
            <path id="Vector_252" d="M38.9161 34.5948H36.7539V36.757H38.9161V34.5948Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_506">
          <g id="Group_507">
            <path id="Vector_253" d="M41.0806 34.5947H38.9185V36.7568H41.0806V34.5947Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_508">
          <g id="Group_509">
            <path id="Vector_254" d="M45.4083 34.5948H43.2461V36.757H45.4083V34.5948Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_510">
          <g id="Group_511">
            <path id="Vector_255" d="M49.7295 34.5947H47.5674V36.7568H49.7295V34.5947Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_512">
          <g id="Group_513">
            <path id="Vector_256" d="M51.8897 34.5948H49.7275V36.757H51.8897V34.5948Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_514">
          <g id="Group_515">
            <path id="Vector_257" d="M54.0545 34.5947H51.8923V36.7568H54.0545V34.5947Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_516">
          <g id="Group_517">
            <path id="Vector_258" d="M56.2164 34.5947H54.0542V36.7568H56.2164V34.5947Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_518">
          <g id="Group_519">
            <path id="Vector_259" d="M58.377 34.5948H56.2148V36.757H58.377V34.5948Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_520">
          <g id="Group_521">
            <path id="Vector_260" d="M60.5416 34.5948H58.3794V36.757H60.5416V34.5948Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_522">
          <g id="Group_523">
            <path id="Vector_261" d="M64.8638 34.5948H62.7017V36.757H64.8638V34.5948Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_524">
          <g id="Group_525">
            <path id="Vector_262" d="M67.0281 34.5947H64.866V36.7568H67.0281V34.5947Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_526">
          <g id="Group_527">
            <path id="Vector_263" d="M69.1898 34.5947H67.0276V36.7568H69.1898V34.5947Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_528">
          <g id="Group_529">
            <path id="Vector_264" d="M71.3548 34.5948H69.1926V36.757H71.3548V34.5948Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_530">
          <g id="Group_531">
            <path id="Vector_265" d="M75.6771 34.5947H73.5149V36.7568H75.6771V34.5947Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_532">
          <g id="Group_533">
            <path id="Vector_266" d="M2.16216 36.7569H0V38.919H2.16216V36.7569Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_534">
          <g id="Group_535">
            <path id="Vector_267" d="M4.32354 36.7569H2.16138V38.919H4.32354V36.7569Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_536">
          <g id="Group_537">
            <path id="Vector_268" d="M6.48735 36.7567H4.3252V38.9189H6.48735V36.7567Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_538">
          <g id="Group_539">
            <path id="Vector_269" d="M12.9695 36.7567H10.8074V38.9189H12.9695V36.7567Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_540">
          <g id="Group_541">
            <path id="Vector_270" d="M17.2962 36.7569H15.134V38.919H17.2962V36.7569Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_542">
          <g id="Group_543">
            <path id="Vector_271" d="M21.6204 36.7569H19.4583V38.919H21.6204V36.7569Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_544">
          <g id="Group_545">
            <path id="Vector_272" d="M25.9473 36.7567H23.7852V38.9189H25.9473V36.7567Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_546">
          <g id="Group_547">
            <path id="Vector_273" d="M34.5948 36.7569H32.4326V38.919H34.5948V36.7569Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_548">
          <g id="Group_549">
            <path id="Vector_274" d="M43.2437 36.7569H41.0815V38.919H43.2437V36.7569Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_550">
          <g id="Group_551">
            <path id="Vector_275" d="M45.4083 36.7567H43.2461V38.9189H45.4083V36.7567Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_552">
          <g id="Group_553">
            <path id="Vector_276" d="M49.7295 36.7569H47.5674V38.919H49.7295V36.7569Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_554">
          <g id="Group_555">
            <path id="Vector_277" d="M51.8897 36.7567H49.7275V38.9189H51.8897V36.7567Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_556">
          <g id="Group_557">
            <path id="Vector_278" d="M56.2164 36.7569H54.0542V38.919H56.2164V36.7569Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_558">
          <g id="Group_559">
            <path id="Vector_279" d="M62.7039 36.7569H60.5417V38.919H62.7039V36.7569Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_560">
          <g id="Group_561">
            <path id="Vector_280" d="M64.8638 36.7567H62.7017V38.9189H64.8638V36.7567Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_562">
          <g id="Group_563">
            <path id="Vector_281" d="M69.1898 36.7569H67.0276V38.919H69.1898V36.7569Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_564">
          <g id="Group_565">
            <path id="Vector_282" d="M75.6771 36.7569H73.5149V38.919H75.6771V36.7569Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_566">
          <g id="Group_567">
            <path id="Vector_283" d="M77.8369 36.7567H75.6748V38.9189H77.8369V36.7567Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_568">
          <g id="Group_569">
            <path id="Vector_284" d="M2.16216 38.9189H0V41.081H2.16216V38.9189Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_570">
          <g id="Group_571">
            <path id="Vector_285" d="M15.1346 38.9189H12.9724V41.081H15.1346V38.9189Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_572">
          <g id="Group_573">
            <path id="Vector_286" d="M17.2962 38.9189H15.134V41.081H17.2962V38.9189Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_574">
          <g id="Group_575">
            <path id="Vector_287" d="M19.4605 38.9185H17.2983V41.0807H19.4605V38.9185Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_576">
          <g id="Group_577">
            <path id="Vector_288" d="M23.7828 38.9185H21.6206V41.0807H23.7828V38.9185Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_578">
          <g id="Group_579">
            <path id="Vector_289" d="M25.9473 38.9185H23.7852V41.0807H25.9473V38.9185Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_580">
          <g id="Group_581">
            <path id="Vector_290" d="M28.108 38.9189H25.9458V41.081H28.108V38.9189Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_582">
          <g id="Group_583">
            <path id="Vector_291" d="M30.2698 38.9189H28.1077V41.081H30.2698V38.9189Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_584">
          <g id="Group_585">
            <path id="Vector_292" d="M32.4346 38.9185H30.2725V41.0807H32.4346V38.9185Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_586">
          <g id="Group_587">
            <path id="Vector_293" d="M34.5948 38.9189H32.4326V41.081H34.5948V38.9189Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_588">
          <g id="Group_589">
            <path id="Vector_294" d="M36.7564 38.9189H34.5942V41.081H36.7564V38.9189Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_590">
          <g id="Group_591">
            <path id="Vector_295" d="M45.4083 38.9185H43.2461V41.0807H45.4083V38.9185Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_592">
          <g id="Group_593">
            <path id="Vector_296" d="M49.7295 38.9189H47.5674V41.081H49.7295V38.9189Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_594">
          <g id="Group_595">
            <path id="Vector_297" d="M54.0545 38.9189H51.8923V41.081H54.0545V38.9189Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_596">
          <g id="Group_597">
            <path id="Vector_298" d="M58.377 38.9185H56.2148V41.0807H58.377V38.9185Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_598">
          <g id="Group_599">
            <path id="Vector_299" d="M60.5416 38.9185H58.3794V41.0807H60.5416V38.9185Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_600">
          <g id="Group_601">
            <path id="Vector_300" d="M64.8638 38.9185H62.7017V41.0807H64.8638V38.9185Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_602">
          <g id="Group_603">
            <path id="Vector_301" d="M69.1898 38.9189H67.0276V41.081H69.1898V38.9189Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_604">
          <g id="Group_605">
            <path id="Vector_302" d="M71.3548 38.9185H69.1926V41.0807H71.3548V38.9185Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_606">
          <g id="Group_607">
            <path id="Vector_303" d="M77.8369 38.9185H75.6748V41.0807H77.8369V38.9185Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_608">
          <g id="Group_609">
            <path id="Vector_304" d="M80.0008 38.9189H77.8386V41.081H80.0008V38.9189Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_610">
          <g id="Group_611">
            <path id="Vector_305" d="M4.32354 41.0811H2.16138V43.2433H4.32354V41.0811Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_612">
          <g id="Group_613">
            <path id="Vector_306" d="M6.48735 41.0815H4.3252V43.2436H6.48735V41.0815Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_614">
          <g id="Group_615">
            <path id="Vector_307" d="M19.4605 41.0815H17.2983V43.2436H19.4605V41.0815Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_616">
          <g id="Group_617">
            <path id="Vector_308" d="M21.6204 41.0811H19.4583V43.2433H21.6204V41.0811Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_618">
          <g id="Group_619">
            <path id="Vector_309" d="M23.7828 41.0815H21.6206V43.2436H23.7828V41.0815Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_620">
          <g id="Group_621">
            <path id="Vector_310" d="M28.108 41.0811H25.9458V43.2433H28.108V41.0811Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_622">
          <g id="Group_623">
            <path id="Vector_311" d="M30.2698 41.0811H28.1077V43.2433H30.2698V41.0811Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_624">
          <g id="Group_625">
            <path id="Vector_312" d="M34.5948 41.0811H32.4326V43.2433H34.5948V41.0811Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_626">
          <g id="Group_627">
            <path id="Vector_313" d="M41.0806 41.0811H38.9185V43.2433H41.0806V41.0811Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_628">
          <g id="Group_629">
            <path id="Vector_314" d="M43.2437 41.0811H41.0815V43.2433H43.2437V41.0811Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_630">
          <g id="Group_631">
            <path id="Vector_315" d="M47.5679 41.0811H45.4058V43.2433H47.5679V41.0811Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_632">
          <g id="Group_633">
            <path id="Vector_316" d="M49.7295 41.0811H47.5674V43.2433H49.7295V41.0811Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_634">
          <g id="Group_635">
            <path id="Vector_317" d="M51.8897 41.0815H49.7275V43.2436H51.8897V41.0815Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_636">
          <g id="Group_637">
            <path id="Vector_318" d="M54.0545 41.0811H51.8923V43.2433H54.0545V41.0811Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_638">
          <g id="Group_639">
            <path id="Vector_319" d="M62.7039 41.0811H60.5417V43.2433H62.7039V41.0811Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_640">
          <g id="Group_641">
            <path id="Vector_320" d="M67.0281 41.0811H64.866V43.2433H67.0281V41.0811Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_642">
          <g id="Group_643">
            <path id="Vector_321" d="M80.0008 41.0811H77.8386V43.2433H80.0008V41.0811Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_644">
          <g id="Group_645">
            <path id="Vector_322" d="M8.64727 43.2431H6.48511V45.4053H8.64727V43.2431Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_646">
          <g id="Group_647">
            <path id="Vector_323" d="M12.9695 43.2433H10.8074V45.4054H12.9695V43.2433Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_648">
          <g id="Group_649">
            <path id="Vector_324" d="M15.1346 43.2431H12.9724V45.4053H15.1346V43.2431Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_650">
          <g id="Group_651">
            <path id="Vector_325" d="M17.2962 43.2431H15.134V45.4053H17.2962V43.2431Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_652">
          <g id="Group_653">
            <path id="Vector_326" d="M19.4605 43.2433H17.2983V45.4054H19.4605V43.2433Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_654">
          <g id="Group_655">
            <path id="Vector_327" d="M21.6204 43.2431H19.4583V45.4053H21.6204V43.2431Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_656">
          <g id="Group_657">
            <path id="Vector_328" d="M25.9473 43.2433H23.7852V45.4054H25.9473V43.2433Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_658">
          <g id="Group_659">
            <path id="Vector_329" d="M30.2698 43.2431H28.1077V45.4053H30.2698V43.2431Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_660">
          <g id="Group_661">
            <path id="Vector_330" d="M32.4346 43.2433H30.2725V45.4054H32.4346V43.2433Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_662">
          <g id="Group_663">
            <path id="Vector_331" d="M34.5948 43.2431H32.4326V45.4053H34.5948V43.2431Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_664">
          <g id="Group_665">
            <path id="Vector_332" d="M38.9161 43.2433H36.7539V45.4054H38.9161V43.2433Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_666">
          <g id="Group_667">
            <path id="Vector_333" d="M45.4083 43.2433H43.2461V45.4054H45.4083V43.2433Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_668">
          <g id="Group_669">
            <path id="Vector_334" d="M49.7295 43.2431H47.5674V45.4053H49.7295V43.2431Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_670">
          <g id="Group_671">
            <path id="Vector_335" d="M54.0545 43.2431H51.8923V45.4053H54.0545V43.2431Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_672">
          <g id="Group_673">
            <path id="Vector_336" d="M56.2164 43.2431H54.0542V45.4053H56.2164V43.2431Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_674">
          <g id="Group_675">
            <path id="Vector_337" d="M58.377 43.2433H56.2148V45.4054H58.377V43.2433Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_676">
          <g id="Group_677">
            <path id="Vector_338" d="M64.8638 43.2433H62.7017V45.4054H64.8638V43.2433Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_678">
          <g id="Group_679">
            <path id="Vector_339" d="M67.0281 43.2431H64.866V45.4053H67.0281V43.2431Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_680">
          <g id="Group_681">
            <path id="Vector_340" d="M71.3548 43.2433H69.1926V45.4054H71.3548V43.2433Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_682">
          <g id="Group_683">
            <path id="Vector_341" d="M75.6771 43.2431H73.5149V45.4053H75.6771V43.2431Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_684">
          <g id="Group_685">
            <path id="Vector_342" d="M2.16216 45.4053H0V47.5675H2.16216V45.4053Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_686">
          <g id="Group_687">
            <path id="Vector_343" d="M4.32354 45.4053H2.16138V47.5675H4.32354V45.4053Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_688">
          <g id="Group_689">
            <path id="Vector_344" d="M6.48735 45.4052H4.3252V47.5673H6.48735V45.4052Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_690">
          <g id="Group_691">
            <path id="Vector_345" d="M8.64727 45.4053H6.48511V47.5675H8.64727V45.4053Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_692">
          <g id="Group_693">
            <path id="Vector_346" d="M10.8101 45.4052H8.64795V47.5673H10.8101V45.4052Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_694">
          <g id="Group_695">
            <path id="Vector_347" d="M12.9695 45.4052H10.8074V47.5673H12.9695V45.4052Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_696">
          <g id="Group_697">
            <path id="Vector_348" d="M25.9473 45.4052H23.7852V47.5673H25.9473V45.4052Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_698">
          <g id="Group_699">
            <path id="Vector_349" d="M28.108 45.4053H25.9458V47.5675H28.108V45.4053Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_700">
          <g id="Group_701">
            <path id="Vector_350" d="M30.2698 45.4053H28.1077V47.5675H30.2698V45.4053Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_702">
          <g id="Group_703">
            <path id="Vector_351" d="M36.7564 45.4053H34.5942V47.5675H36.7564V45.4053Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_704">
          <g id="Group_705">
            <path id="Vector_352" d="M38.9161 45.4052H36.7539V47.5673H38.9161V45.4052Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_706">
          <g id="Group_707">
            <path id="Vector_353" d="M41.0806 45.4053H38.9185V47.5675H41.0806V45.4053Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_708">
          <g id="Group_709">
            <path id="Vector_354" d="M43.2437 45.4053H41.0815V47.5675H43.2437V45.4053Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_710">
          <g id="Group_711">
            <path id="Vector_355" d="M45.4083 45.4052H43.2461V47.5673H45.4083V45.4052Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_712">
          <g id="Group_713">
            <path id="Vector_356" d="M47.5679 45.4053H45.4058V47.5675H47.5679V45.4053Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_714">
          <g id="Group_715">
            <path id="Vector_357" d="M49.7295 45.4053H47.5674V47.5675H49.7295V45.4053Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_716">
          <g id="Group_717">
            <path id="Vector_358" d="M51.8897 45.4052H49.7275V47.5673H51.8897V45.4052Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_718">
          <g id="Group_719">
            <path id="Vector_359" d="M56.2164 45.4053H54.0542V47.5675H56.2164V45.4053Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_720">
          <g id="Group_721">
            <path id="Vector_360" d="M62.7039 45.4053H60.5417V47.5675H62.7039V45.4053Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_722">
          <g id="Group_723">
            <path id="Vector_361" d="M73.5142 45.4052H71.3521V47.5673H73.5142V45.4052Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_724">
          <g id="Group_725">
            <path id="Vector_362" d="M8.64727 47.5676H6.48511V49.7297H8.64727V47.5676Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_726">
          <g id="Group_727">
            <path id="Vector_363" d="M10.8101 47.5681H8.64795V49.7302H10.8101V47.5681Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_728">
          <g id="Group_729">
            <path id="Vector_364" d="M12.9695 47.5681H10.8074V49.7302H12.9695V47.5681Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_730">
          <g id="Group_731">
            <path id="Vector_365" d="M15.1346 47.5676H12.9724V49.7297H15.1346V47.5676Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_732">
          <g id="Group_733">
            <path id="Vector_366" d="M21.6204 47.5676H19.4583V49.7297H21.6204V47.5676Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_734">
          <g id="Group_735">
            <path id="Vector_367" d="M28.108 47.5676H25.9458V49.7297H28.108V47.5676Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_736">
          <g id="Group_737">
            <path id="Vector_368" d="M30.2698 47.5676H28.1077V49.7297H30.2698V47.5676Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_738">
          <g id="Group_739">
            <path id="Vector_369" d="M34.5948 47.5676H32.4326V49.7297H34.5948V47.5676Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_740">
          <g id="Group_741">
            <path id="Vector_370" d="M36.7564 47.5676H34.5942V49.7297H36.7564V47.5676Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_742">
          <g id="Group_743">
            <path id="Vector_371" d="M45.4083 47.5681H43.2461V49.7302H45.4083V47.5681Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_744">
          <g id="Group_745">
            <path id="Vector_372" d="M56.2164 47.5676H54.0542V49.7297H56.2164V47.5676Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_746">
          <g id="Group_747">
            <path id="Vector_373" d="M58.377 47.5681H56.2148V49.7302H58.377V47.5681Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_748">
          <g id="Group_749">
            <path id="Vector_374" d="M60.5416 47.5681H58.3794V49.7302H60.5416V47.5681Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_750">
          <g id="Group_751">
            <path id="Vector_375" d="M64.8638 47.5681H62.7017V49.7302H64.8638V47.5681Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_752">
          <g id="Group_753">
            <path id="Vector_376" d="M67.0281 47.5676H64.866V49.7297H67.0281V47.5676Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_754">
          <g id="Group_755">
            <path id="Vector_377" d="M69.1898 47.5676H67.0276V49.7297H69.1898V47.5676Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_756">
          <g id="Group_757">
            <path id="Vector_378" d="M71.3548 47.5681H69.1926V49.7302H71.3548V47.5681Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_758">
          <g id="Group_759">
            <path id="Vector_379" d="M73.5142 47.5681H71.3521V49.7302H73.5142V47.5681Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_760">
          <g id="Group_761">
            <path id="Vector_380" d="M77.8369 47.5681H75.6748V49.7302H77.8369V47.5681Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_762">
          <g id="Group_763">
            <path id="Vector_381" d="M80.0008 47.5676H77.8386V49.7297H80.0008V47.5676Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_764">
          <g id="Group_765">
            <path id="Vector_382" d="M4.32354 49.7298H2.16138V51.892H4.32354V49.7298Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_766">
          <g id="Group_767">
            <path id="Vector_383" d="M6.48735 49.7299H4.3252V51.892H6.48735V49.7299Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_768">
          <g id="Group_769">
            <path id="Vector_384" d="M10.8101 49.7299H8.64795V51.892H10.8101V49.7299Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_770">
          <g id="Group_771">
            <path id="Vector_385" d="M12.9695 49.7299H10.8074V51.892H12.9695V49.7299Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_772">
          <g id="Group_773">
            <path id="Vector_386" d="M17.2962 49.7298H15.134V51.892H17.2962V49.7298Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_774">
          <g id="Group_775">
            <path id="Vector_387" d="M19.4605 49.7299H17.2983V51.892H19.4605V49.7299Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_776">
          <g id="Group_777">
            <path id="Vector_388" d="M21.6204 49.7298H19.4583V51.892H21.6204V49.7298Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_778">
          <g id="Group_779">
            <path id="Vector_389" d="M25.9473 49.7299H23.7852V51.892H25.9473V49.7299Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_780">
          <g id="Group_781">
            <path id="Vector_390" d="M28.108 49.7298H25.9458V51.892H28.108V49.7298Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_782">
          <g id="Group_783">
            <path id="Vector_391" d="M34.5948 49.7298H32.4326V51.892H34.5948V49.7298Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_784">
          <g id="Group_785">
            <path id="Vector_392" d="M47.5679 49.7298H45.4058V51.892H47.5679V49.7298Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_786">
          <g id="Group_787">
            <path id="Vector_393" d="M51.8897 49.7299H49.7275V51.892H51.8897V49.7299Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_788">
          <g id="Group_789">
            <path id="Vector_394" d="M58.377 49.7299H56.2148V51.892H58.377V49.7299Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_790">
          <g id="Group_791">
            <path id="Vector_395" d="M62.7039 49.7298H60.5417V51.892H62.7039V49.7298Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_792">
          <g id="Group_793">
            <path id="Vector_396" d="M69.1898 49.7298H67.0276V51.892H69.1898V49.7298Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_794">
          <g id="Group_795">
            <path id="Vector_397" d="M71.3548 49.7299H69.1926V51.892H71.3548V49.7299Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_796">
          <g id="Group_797">
            <path id="Vector_398" d="M77.8369 49.7299H75.6748V51.892H77.8369V49.7299Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_798">
          <g id="Group_799">
            <path id="Vector_399" d="M4.32354 51.892H2.16138V54.0542H4.32354V51.892Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_800">
          <g id="Group_801">
            <path id="Vector_400" d="M10.8101 51.8918H8.64795V54.0539H10.8101V51.8918Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_802">
          <g id="Group_803">
            <path id="Vector_401" d="M12.9695 51.8918H10.8074V54.0539H12.9695V51.8918Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_804">
          <g id="Group_805">
            <path id="Vector_402" d="M15.1346 51.892H12.9724V54.0542H15.1346V51.892Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_806">
          <g id="Group_807">
            <path id="Vector_403" d="M17.2962 51.892H15.134V54.0542H17.2962V51.892Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_808">
          <g id="Group_809">
            <path id="Vector_404" d="M21.6204 51.892H19.4583V54.0542H21.6204V51.892Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_810">
          <g id="Group_811">
            <path id="Vector_405" d="M25.9473 51.8918H23.7852V54.0539H25.9473V51.8918Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_812">
          <g id="Group_813">
            <path id="Vector_406" d="M28.108 51.892H25.9458V54.0542H28.108V51.892Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_814">
          <g id="Group_815">
            <path id="Vector_407" d="M38.9161 51.8918H36.7539V54.0539H38.9161V51.8918Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_816">
          <g id="Group_817">
            <path id="Vector_408" d="M49.7295 51.892H47.5674V54.0542H49.7295V51.892Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_818">
          <g id="Group_819">
            <path id="Vector_409" d="M51.8897 51.8918H49.7275V54.0539H51.8897V51.8918Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_820">
          <g id="Group_821">
            <path id="Vector_410" d="M54.0545 51.892H51.8923V54.0542H54.0545V51.892Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_822">
          <g id="Group_823">
            <path id="Vector_411" d="M56.2164 51.892H54.0542V54.0542H56.2164V51.892Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_824">
          <g id="Group_825">
            <path id="Vector_412" d="M58.377 51.8918H56.2148V54.0539H58.377V51.8918Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_826">
          <g id="Group_827">
            <path id="Vector_413" d="M64.8638 51.8918H62.7017V54.0539H64.8638V51.8918Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_828">
          <g id="Group_829">
            <path id="Vector_414" d="M67.0281 51.892H64.866V54.0542H67.0281V51.892Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_830">
          <g id="Group_831">
            <path id="Vector_415" d="M69.1898 51.892H67.0276V54.0542H69.1898V51.892Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_832">
          <g id="Group_833">
            <path id="Vector_416" d="M71.3548 51.8918H69.1926V54.0539H71.3548V51.8918Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_834">
          <g id="Group_835">
            <path id="Vector_417" d="M75.6771 51.892H73.5149V54.0542H75.6771V51.892Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_836">
          <g id="Group_837">
            <path id="Vector_418" d="M77.8369 51.8918H75.6748V54.0539H77.8369V51.8918Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_838">
          <g id="Group_839">
            <path id="Vector_419" d="M2.16216 54.0541H0V56.2162H2.16216V54.0541Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_840">
          <g id="Group_841">
            <path id="Vector_420" d="M4.32354 54.0541H2.16138V56.2162H4.32354V54.0541Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_842">
          <g id="Group_843">
            <path id="Vector_421" d="M8.64727 54.0541H6.48511V56.2162H8.64727V54.0541Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_844">
          <g id="Group_845">
            <path id="Vector_422" d="M10.8101 54.0536H8.64795V56.2157H10.8101V54.0536Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_846">
          <g id="Group_847">
            <path id="Vector_423" d="M12.9695 54.0536H10.8074V56.2157H12.9695V54.0536Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_848">
          <g id="Group_849">
            <path id="Vector_424" d="M19.4605 54.0536H17.2983V56.2157H19.4605V54.0536Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_850">
          <g id="Group_851">
            <path id="Vector_425" d="M21.6204 54.0541H19.4583V56.2162H21.6204V54.0541Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_852">
          <g id="Group_853">
            <path id="Vector_426" d="M23.7828 54.0536H21.6206V56.2157H23.7828V54.0536Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_854">
          <g id="Group_855">
            <path id="Vector_427" d="M25.9473 54.0536H23.7852V56.2157H25.9473V54.0536Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_856">
          <g id="Group_857">
            <path id="Vector_428" d="M28.108 54.0541H25.9458V56.2162H28.108V54.0541Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_858">
          <g id="Group_859">
            <path id="Vector_429" d="M30.2698 54.0541H28.1077V56.2162H30.2698V54.0541Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_860">
          <g id="Group_861">
            <path id="Vector_430" d="M32.4346 54.0536H30.2725V56.2157H32.4346V54.0536Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_862">
          <g id="Group_863">
            <path id="Vector_431" d="M34.5948 54.0541H32.4326V56.2162H34.5948V54.0541Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_864">
          <g id="Group_865">
            <path id="Vector_432" d="M36.7564 54.0541H34.5942V56.2162H36.7564V54.0541Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_866">
          <g id="Group_867">
            <path id="Vector_433" d="M43.2437 54.0541H41.0815V56.2162H43.2437V54.0541Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_868">
          <g id="Group_869">
            <path id="Vector_434" d="M45.4083 54.0536H43.2461V56.2157H45.4083V54.0536Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_870">
          <g id="Group_871">
            <path id="Vector_435" d="M47.5679 54.0541H45.4058V56.2162H47.5679V54.0541Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_872">
          <g id="Group_873">
            <path id="Vector_436" d="M51.8897 54.0536H49.7275V56.2157H51.8897V54.0536Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_874">
          <g id="Group_875">
            <path id="Vector_437" d="M69.1898 54.0541H67.0276V56.2162H69.1898V54.0541Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_876">
          <g id="Group_877">
            <path id="Vector_438" d="M73.5142 54.0536H71.3521V56.2157H73.5142V54.0536Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_878">
          <g id="Group_879">
            <path id="Vector_439" d="M2.16216 56.2163H0V58.3785H2.16216V56.2163Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_880">
          <g id="Group_881">
            <path id="Vector_440" d="M8.64727 56.2163H6.48511V58.3785H8.64727V56.2163Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_882">
          <g id="Group_883">
            <path id="Vector_441" d="M15.1346 56.2163H12.9724V58.3785H15.1346V56.2163Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_884">
          <g id="Group_885">
            <path id="Vector_442" d="M21.6204 56.2163H19.4583V58.3785H21.6204V56.2163Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_886">
          <g id="Group_887">
            <path id="Vector_443" d="M25.9473 56.2165H23.7852V58.3786H25.9473V56.2165Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_888">
          <g id="Group_889">
            <path id="Vector_444" d="M45.4083 56.2165H43.2461V58.3786H45.4083V56.2165Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_890">
          <g id="Group_891">
            <path id="Vector_445" d="M54.0545 56.2163H51.8923V58.3785H54.0545V56.2163Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_892">
          <g id="Group_893">
            <path id="Vector_446" d="M58.377 56.2165H56.2148V58.3786H58.377V56.2165Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_894">
          <g id="Group_895">
            <path id="Vector_447" d="M60.5416 56.2165H58.3794V58.3786H60.5416V56.2165Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_896">
          <g id="Group_897">
            <path id="Vector_448" d="M62.7039 56.2163H60.5417V58.3785H62.7039V56.2163Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_898">
          <g id="Group_899">
            <path id="Vector_449" d="M67.0281 56.2163H64.866V58.3785H67.0281V56.2163Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_900">
          <g id="Group_901">
            <path id="Vector_450" d="M71.3548 56.2165H69.1926V58.3786H71.3548V56.2165Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_902">
          <g id="Group_903">
            <path id="Vector_451" d="M73.5142 56.2165H71.3521V58.3786H73.5142V56.2165Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_904">
          <g id="Group_905">
            <path id="Vector_452" d="M75.6771 56.2163H73.5149V58.3785H75.6771V56.2163Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_906">
          <g id="Group_907">
            <path id="Vector_453" d="M77.8369 56.2165H75.6748V58.3786H77.8369V56.2165Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_908">
          <g id="Group_909">
            <path id="Vector_454" d="M80.0008 56.2163H77.8386V58.3785H80.0008V56.2163Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_910">
          <g id="Group_911">
            <path id="Vector_455" d="M2.16216 58.3785H0V60.5406H2.16216V58.3785Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_912">
          <g id="Group_913">
            <path id="Vector_456" d="M6.48735 58.3784H4.3252V60.5406H6.48735V58.3784Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_914">
          <g id="Group_915">
            <path id="Vector_457" d="M8.64727 58.3785H6.48511V60.5406H8.64727V58.3785Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_916">
          <g id="Group_917">
            <path id="Vector_458" d="M21.6204 58.3785H19.4583V60.5406H21.6204V58.3785Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_918">
          <g id="Group_919">
            <path id="Vector_459" d="M23.7828 58.3784H21.6206V60.5406H23.7828V58.3784Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_920">
          <g id="Group_921">
            <path id="Vector_460" d="M30.2698 58.3785H28.1077V60.5406H30.2698V58.3785Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_922">
          <g id="Group_923">
            <path id="Vector_461" d="M36.7564 58.3785H34.5942V60.5406H36.7564V58.3785Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_924">
          <g id="Group_925">
            <path id="Vector_462" d="M45.4083 58.3784H43.2461V60.5406H45.4083V58.3784Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_926">
          <g id="Group_927">
            <path id="Vector_463" d="M47.5679 58.3785H45.4058V60.5406H47.5679V58.3785Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_928">
          <g id="Group_929">
            <path id="Vector_464" d="M51.8897 58.3784H49.7275V60.5406H51.8897V58.3784Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_930">
          <g id="Group_931">
            <path id="Vector_465" d="M58.377 58.3784H56.2148V60.5406H58.377V58.3784Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_932">
          <g id="Group_933">
            <path id="Vector_466" d="M60.5416 58.3784H58.3794V60.5406H60.5416V58.3784Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_934">
          <g id="Group_935">
            <path id="Vector_467" d="M64.8638 58.3784H62.7017V60.5406H64.8638V58.3784Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_936">
          <g id="Group_937">
            <path id="Vector_468" d="M67.0281 58.3785H64.866V60.5406H67.0281V58.3785Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_938">
          <g id="Group_939">
            <path id="Vector_469" d="M69.1898 58.3785H67.0276V60.5406H69.1898V58.3785Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_940">
          <g id="Group_941">
            <path id="Vector_470" d="M71.3548 58.3784H69.1926V60.5406H71.3548V58.3784Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_942">
          <g id="Group_943">
            <path id="Vector_471" d="M77.8369 58.3784H75.6748V60.5406H77.8369V58.3784Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_944">
          <g id="Group_945">
            <path id="Vector_472" d="M80.0008 58.3785H77.8386V60.5406H80.0008V58.3785Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_946">
          <g id="Group_947">
            <path id="Vector_473" d="M2.16216 60.5405H0V62.7026H2.16216V60.5405Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_948">
          <g id="Group_949">
            <path id="Vector_474" d="M12.9695 60.5402H10.8074V62.7024H12.9695V60.5402Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_950">
          <g id="Group_951">
            <path id="Vector_475" d="M15.1346 60.5405H12.9724V62.7026H15.1346V60.5405Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_952">
          <g id="Group_953">
            <path id="Vector_476" d="M17.2962 60.5405H15.134V62.7026H17.2962V60.5405Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_954">
          <g id="Group_955">
            <path id="Vector_477" d="M19.4605 60.5402H17.2983V62.7024H19.4605V60.5402Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_956">
          <g id="Group_957">
            <path id="Vector_478" d="M25.9473 60.5402H23.7852V62.7024H25.9473V60.5402Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_958">
          <g id="Group_959">
            <path id="Vector_479" d="M28.108 60.5405H25.9458V62.7026H28.108V60.5405Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_960">
          <g id="Group_961">
            <path id="Vector_480" d="M38.9161 60.5402H36.7539V62.7024H38.9161V60.5402Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_962">
          <g id="Group_963">
            <path id="Vector_481" d="M49.7295 60.5405H47.5674V62.7026H49.7295V60.5405Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_964">
          <g id="Group_965">
            <path id="Vector_482" d="M51.8897 60.5402H49.7275V62.7024H51.8897V60.5402Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_966">
          <g id="Group_967">
            <path id="Vector_483" d="M54.0545 60.5405H51.8923V62.7026H54.0545V60.5405Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_968">
          <g id="Group_969">
            <path id="Vector_484" d="M56.2164 60.5405H54.0542V62.7026H56.2164V60.5405Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_970">
          <g id="Group_971">
            <path id="Vector_485" d="M62.7039 60.5405H60.5417V62.7026H62.7039V60.5405Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_972">
          <g id="Group_973">
            <path id="Vector_486" d="M64.8638 60.5402H62.7017V62.7024H64.8638V60.5402Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_974">
          <g id="Group_975">
            <path id="Vector_487" d="M67.0281 60.5405H64.866V62.7026H67.0281V60.5405Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_976">
          <g id="Group_977">
            <path id="Vector_488" d="M69.1898 60.5405H67.0276V62.7026H69.1898V60.5405Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_978">
          <g id="Group_979">
            <path id="Vector_489" d="M71.3548 60.5402H69.1926V62.7024H71.3548V60.5402Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_980">
          <g id="Group_981">
            <path id="Vector_490" d="M75.6771 60.5405H73.5149V62.7026H75.6771V60.5405Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_982">
          <g id="Group_983">
            <path id="Vector_491" d="M80.0008 60.5405H77.8386V62.7026H80.0008V60.5405Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_984">
          <g id="Group_985">
            <path id="Vector_492" d="M19.4605 62.702H17.2983V64.8641H19.4605V62.702Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_986">
          <g id="Group_987">
            <path id="Vector_493" d="M21.6204 62.7026H19.4583V64.8647H21.6204V62.7026Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_988">
          <g id="Group_989">
            <path id="Vector_494" d="M25.9473 62.702H23.7852V64.8641H25.9473V62.702Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_990">
          <g id="Group_991">
            <path id="Vector_495" d="M36.7564 62.7026H34.5942V64.8647H36.7564V62.7026Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_992">
          <g id="Group_993">
            <path id="Vector_496" d="M43.2437 62.7026H41.0815V64.8647H43.2437V62.7026Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_994">
          <g id="Group_995">
            <path id="Vector_497" d="M45.4083 62.702H43.2461V64.8641H45.4083V62.702Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_996">
          <g id="Group_997">
            <path id="Vector_498" d="M51.8897 62.702H49.7275V64.8641H51.8897V62.702Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_998">
          <g id="Group_999">
            <path id="Vector_499" d="M56.2164 62.7026H54.0542V64.8647H56.2164V62.7026Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_1000">
          <g id="Group_1001">
            <path id="Vector_500" d="M60.5416 62.702H58.3794V64.8641H60.5416V62.702Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_1002">
          <g id="Group_1003">
            <path id="Vector_501" d="M62.7039 62.7026H60.5417V64.8647H62.7039V62.7026Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_1004">
          <g id="Group_1005">
            <path id="Vector_502" d="M71.3548 62.702H69.1926V64.8641H71.3548V62.702Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_1006">
          <g id="Group_1007">
            <path id="Vector_503" d="M73.5142 62.702H71.3521V64.8641H73.5142V62.702Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_1008">
          <g id="Group_1009">
            <path id="Vector_504" d="M77.8369 62.702H75.6748V64.8641H77.8369V62.702Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_1010">
          <g id="Group_1011">
            <path id="Vector_505" d="M21.6204 64.8648H19.4583V67.027H21.6204V64.8648Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_1012">
          <g id="Group_1013">
            <path id="Vector_506" d="M28.108 64.8648H25.9458V67.027H28.108V64.8648Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_1014">
          <g id="Group_1015">
            <path id="Vector_507" d="M34.5948 64.8648H32.4326V67.027H34.5948V64.8648Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_1016">
          <g id="Group_1017">
            <path id="Vector_508" d="M36.7564 64.8648H34.5942V67.027H36.7564V64.8648Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_1018">
          <g id="Group_1019">
            <path id="Vector_509" d="M38.9161 64.8649H36.7539V67.027H38.9161V64.8649Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_1020">
          <g id="Group_1021">
            <path id="Vector_510" d="M41.0806 64.8648H38.9185V67.027H41.0806V64.8648Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_1022">
          <g id="Group_1023">
            <path id="Vector_511" d="M45.4083 64.8649H43.2461V67.027H45.4083V64.8649Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_1024">
          <g id="Group_1025">
            <path id="Vector_512" d="M49.7295 64.8648H47.5674V67.027H49.7295V64.8648Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_1026">
          <g id="Group_1027">
            <path id="Vector_513" d="M62.7039 64.8648H60.5417V67.027H62.7039V64.8648Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_1028">
          <g id="Group_1029">
            <path id="Vector_514" d="M67.0281 64.8648H64.866V67.027H67.0281V64.8648Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_1030">
          <g id="Group_1031">
            <path id="Vector_515" d="M71.3548 64.8649H69.1926V67.027H71.3548V64.8649Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_1032">
          <g id="Group_1033">
            <path id="Vector_516" d="M75.6771 64.8648H73.5149V67.027H75.6771V64.8648Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_1034">
          <g id="Group_1035">
            <path id="Vector_517" d="M80.0008 64.8648H77.8386V67.027H80.0008V64.8648Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_1036">
          <g id="Group_1037">
            <path id="Vector_518" d="M19.4605 67.0268H17.2983V69.1889H19.4605V67.0268Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_1038">
          <g id="Group_1039">
            <path id="Vector_519" d="M21.6204 67.027H19.4583V69.1892H21.6204V67.027Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_1040">
          <g id="Group_1041">
            <path id="Vector_520" d="M32.4346 67.0268H30.2725V69.1889H32.4346V67.0268Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_1042">
          <g id="Group_1043">
            <path id="Vector_521" d="M34.5948 67.027H32.4326V69.1892H34.5948V67.027Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_1044">
          <g id="Group_1045">
            <path id="Vector_522" d="M41.0806 67.027H38.9185V69.1892H41.0806V67.027Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_1046">
          <g id="Group_1047">
            <path id="Vector_523" d="M43.2437 67.027H41.0815V69.1892H43.2437V67.027Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_1048">
          <g id="Group_1049">
            <path id="Vector_524" d="M45.4083 67.0268H43.2461V69.1889H45.4083V67.0268Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_1050">
          <g id="Group_1051">
            <path id="Vector_525" d="M47.5679 67.027H45.4058V69.1892H47.5679V67.027Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_1052">
          <g id="Group_1053">
            <path id="Vector_526" d="M49.7295 67.027H47.5674V69.1892H49.7295V67.027Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_1054">
          <g id="Group_1055">
            <path id="Vector_527" d="M51.8897 67.0268H49.7275V69.1889H51.8897V67.0268Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_1056">
          <g id="Group_1057">
            <path id="Vector_528" d="M54.0545 67.027H51.8923V69.1892H54.0545V67.027Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_1058">
          <g id="Group_1059">
            <path id="Vector_529" d="M58.377 67.0268H56.2148V69.1889H58.377V67.0268Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_1060">
          <g id="Group_1061">
            <path id="Vector_530" d="M60.5416 67.0268H58.3794V69.1889H60.5416V67.0268Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_1062">
          <g id="Group_1063">
            <path id="Vector_531" d="M62.7039 67.027H60.5417V69.1892H62.7039V67.027Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_1064">
          <g id="Group_1065">
            <path id="Vector_532" d="M71.3548 67.0268H69.1926V69.1889H71.3548V67.0268Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_1066">
          <g id="Group_1067">
            <path id="Vector_533" d="M73.5142 67.0268H71.3521V69.1889H73.5142V67.0268Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_1068">
          <g id="Group_1069">
            <path id="Vector_534" d="M77.8369 67.0268H75.6748V69.1889H77.8369V67.0268Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_1070">
          <g id="Group_1071">
            <path id="Vector_535" d="M19.4605 69.1886H17.2983V71.3508H19.4605V69.1886Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_1072">
          <g id="Group_1073">
            <path id="Vector_536" d="M21.6204 69.1891H19.4583V71.3512H21.6204V69.1891Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_1074">
          <g id="Group_1075">
            <path id="Vector_537" d="M28.108 69.1891H25.9458V71.3512H28.108V69.1891Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_1076">
          <g id="Group_1077">
            <path id="Vector_538" d="M32.4346 69.1886H30.2725V71.3508H32.4346V69.1886Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_1078">
          <g id="Group_1079">
            <path id="Vector_539" d="M34.5948 69.1891H32.4326V71.3512H34.5948V69.1891Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_1080">
          <g id="Group_1081">
            <path id="Vector_540" d="M38.9161 69.1886H36.7539V71.3508H38.9161V69.1886Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_1082">
          <g id="Group_1083">
            <path id="Vector_541" d="M43.2437 69.1891H41.0815V71.3512H43.2437V69.1891Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_1084">
          <g id="Group_1085">
            <path id="Vector_542" d="M45.4083 69.1886H43.2461V71.3508H45.4083V69.1886Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_1086">
          <g id="Group_1087">
            <path id="Vector_543" d="M49.7295 69.1891H47.5674V71.3512H49.7295V69.1891Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_1088">
          <g id="Group_1089">
            <path id="Vector_544" d="M54.0545 69.1891H51.8923V71.3512H54.0545V69.1891Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_1090">
          <g id="Group_1091">
            <path id="Vector_545" d="M56.2164 69.1891H54.0542V71.3512H56.2164V69.1891Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_1092">
          <g id="Group_1093">
            <path id="Vector_546" d="M58.377 69.1886H56.2148V71.3508H58.377V69.1886Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_1094">
          <g id="Group_1095">
            <path id="Vector_547" d="M60.5416 69.1886H58.3794V71.3508H60.5416V69.1886Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_1096">
          <g id="Group_1097">
            <path id="Vector_548" d="M62.7039 69.1891H60.5417V71.3512H62.7039V69.1891Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_1098">
          <g id="Group_1099">
            <path id="Vector_549" d="M64.8638 69.1886H62.7017V71.3508H64.8638V69.1886Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_1100">
          <g id="Group_1101">
            <path id="Vector_550" d="M67.0281 69.1891H64.866V71.3512H67.0281V69.1891Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_1102">
          <g id="Group_1103">
            <path id="Vector_551" d="M69.1898 69.1891H67.0276V71.3512H69.1898V69.1891Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_1104">
          <g id="Group_1105">
            <path id="Vector_552" d="M71.3548 69.1886H69.1926V71.3508H71.3548V69.1886Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_1106">
          <g id="Group_1107">
            <path id="Vector_553" d="M75.6771 69.1891H73.5149V71.3512H75.6771V69.1891Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_1108">
          <g id="Group_1109">
            <path id="Vector_554" d="M80.0008 69.1891H77.8386V71.3512H80.0008V69.1891Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_1110">
          <g id="Group_1111">
            <path id="Vector_555" d="M19.4605 71.3516H17.2983V73.5137H19.4605V71.3516Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_1112">
          <g id="Group_1113">
            <path id="Vector_556" d="M21.6204 71.3513H19.4583V73.5134H21.6204V71.3513Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_1114">
          <g id="Group_1115">
            <path id="Vector_557" d="M25.9473 71.3516H23.7852V73.5137H25.9473V71.3516Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_1116">
          <g id="Group_1117">
            <path id="Vector_558" d="M28.108 71.3513H25.9458V73.5134H28.108V71.3513Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_1118">
          <g id="Group_1119">
            <path id="Vector_559" d="M30.2698 71.3513H28.1077V73.5134H30.2698V71.3513Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_1120">
          <g id="Group_1121">
            <path id="Vector_560" d="M34.5948 71.3513H32.4326V73.5134H34.5948V71.3513Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_1122">
          <g id="Group_1123">
            <path id="Vector_561" d="M43.2437 71.3513H41.0815V73.5134H43.2437V71.3513Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_1124">
          <g id="Group_1125">
            <path id="Vector_562" d="M45.4083 71.3516H43.2461V73.5137H45.4083V71.3516Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_1126">
          <g id="Group_1127">
            <path id="Vector_563" d="M47.5679 71.3513H45.4058V73.5134H47.5679V71.3513Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_1128">
          <g id="Group_1129">
            <path id="Vector_564" d="M51.8897 71.3516H49.7275V73.5137H51.8897V71.3516Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_1130">
          <g id="Group_1131">
            <path id="Vector_565" d="M54.0545 71.3513H51.8923V73.5134H54.0545V71.3513Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_1132">
          <g id="Group_1133">
            <path id="Vector_566" d="M56.2164 71.3513H54.0542V73.5134H56.2164V71.3513Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_1134">
          <g id="Group_1135">
            <path id="Vector_567" d="M64.8638 71.3516H62.7017V73.5137H64.8638V71.3516Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_1136">
          <g id="Group_1137">
            <path id="Vector_568" d="M67.0281 71.3513H64.866V73.5134H67.0281V71.3513Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_1138">
          <g id="Group_1139">
            <path id="Vector_569" d="M71.3548 71.3516H69.1926V73.5137H71.3548V71.3516Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_1140">
          <g id="Group_1141">
            <path id="Vector_570" d="M77.8369 71.3516H75.6748V73.5137H77.8369V71.3516Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_1142">
          <g id="Group_1143">
            <path id="Vector_571" d="M80.0008 71.3513H77.8386V73.5134H80.0008V71.3513Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_1144">
          <g id="Group_1145">
            <path id="Vector_572" d="M19.4605 73.5135H17.2983V75.6757H19.4605V73.5135Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_1146">
          <g id="Group_1147">
            <path id="Vector_573" d="M21.6204 73.5134H19.4583V75.6756H21.6204V73.5134Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_1148">
          <g id="Group_1149">
            <path id="Vector_574" d="M34.5948 73.5134H32.4326V75.6756H34.5948V73.5134Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_1150">
          <g id="Group_1151">
            <path id="Vector_575" d="M36.7564 73.5134H34.5942V75.6756H36.7564V73.5134Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_1152">
          <g id="Group_1153">
            <path id="Vector_576" d="M47.5679 73.5134H45.4058V75.6756H47.5679V73.5134Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_1154">
          <g id="Group_1155">
            <path id="Vector_577" d="M49.7295 73.5134H47.5674V75.6756H49.7295V73.5134Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_1156">
          <g id="Group_1157">
            <path id="Vector_578" d="M54.0545 73.5134H51.8923V75.6756H54.0545V73.5134Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_1158">
          <g id="Group_1159">
            <path id="Vector_579" d="M56.2164 73.5134H54.0542V75.6756H56.2164V73.5134Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_1160">
          <g id="Group_1161">
            <path id="Vector_580" d="M58.377 73.5135H56.2148V75.6757H58.377V73.5135Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_1162">
          <g id="Group_1163">
            <path id="Vector_581" d="M60.5416 73.5135H58.3794V75.6757H60.5416V73.5135Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_1164">
          <g id="Group_1165">
            <path id="Vector_582" d="M62.7039 73.5134H60.5417V75.6756H62.7039V73.5134Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_1166">
          <g id="Group_1167">
            <path id="Vector_583" d="M64.8638 73.5135H62.7017V75.6757H64.8638V73.5135Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_1168">
          <g id="Group_1169">
            <path id="Vector_584" d="M77.8369 73.5135H75.6748V75.6757H77.8369V73.5135Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_1170">
          <g id="Group_1171">
            <path id="Vector_585" d="M80.0008 73.5134H77.8386V75.6756H80.0008V73.5134Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_1172">
          <g id="Group_1173">
            <path id="Vector_586" d="M28.108 75.6757H25.9458V77.8378H28.108V75.6757Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_1174">
          <g id="Group_1175">
            <path id="Vector_587" d="M32.4346 75.6752H30.2725V77.8373H32.4346V75.6752Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_1176">
          <g id="Group_1177">
            <path id="Vector_588" d="M34.5948 75.6757H32.4326V77.8378H34.5948V75.6757Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_1178">
          <g id="Group_1179">
            <path id="Vector_589" d="M36.7564 75.6757H34.5942V77.8378H36.7564V75.6757Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_1180">
          <g id="Group_1181">
            <path id="Vector_590" d="M41.0806 75.6757H38.9185V77.8378H41.0806V75.6757Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_1182">
          <g id="Group_1183">
            <path id="Vector_591" d="M45.4083 75.6752H43.2461V77.8373H45.4083V75.6752Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_1184">
          <g id="Group_1185">
            <path id="Vector_592" d="M47.5679 75.6757H45.4058V77.8378H47.5679V75.6757Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_1186">
          <g id="Group_1187">
            <path id="Vector_593" d="M49.7295 75.6757H47.5674V77.8378H49.7295V75.6757Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_1188">
          <g id="Group_1189">
            <path id="Vector_594" d="M60.5416 75.6752H58.3794V77.8373H60.5416V75.6752Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_1190">
          <g id="Group_1191">
            <path id="Vector_595" d="M62.7039 75.6757H60.5417V77.8378H62.7039V75.6757Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_1192">
          <g id="Group_1193">
            <path id="Vector_596" d="M64.8638 75.6752H62.7017V77.8373H64.8638V75.6752Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_1194">
          <g id="Group_1195">
            <path id="Vector_597" d="M71.3548 75.6752H69.1926V77.8373H71.3548V75.6752Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_1196">
          <g id="Group_1197">
            <path id="Vector_598" d="M73.5142 75.6752H71.3521V77.8373H73.5142V75.6752Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_1198">
          <g id="Group_1199">
            <path id="Vector_599" d="M80.0008 75.6757H77.8386V77.8378H80.0008V75.6757Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_1200">
          <g id="Group_1201">
            <path id="Vector_600" d="M19.4605 77.8381H17.2983V80.0003H19.4605V77.8381Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_1202">
          <g id="Group_1203">
            <path id="Vector_601" d="M30.2698 77.8378H28.1077V79.9999H30.2698V77.8378Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_1204">
          <g id="Group_1205">
            <path id="Vector_602" d="M34.5948 77.8378H32.4326V79.9999H34.5948V77.8378Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_1206">
          <g id="Group_1207">
            <path id="Vector_603" d="M38.9161 77.8381H36.7539V80.0003H38.9161V77.8381Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_1208">
          <g id="Group_1209">
            <path id="Vector_604" d="M54.0545 77.8378H51.8923V79.9999H54.0545V77.8378Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_1210">
          <g id="Group_1211">
            <path id="Vector_605" d="M56.2164 77.8378H54.0542V79.9999H56.2164V77.8378Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_1212">
          <g id="Group_1213">
            <path id="Vector_606" d="M58.377 77.8381H56.2148V80.0003H58.377V77.8381Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_1214">
          <g id="Group_1215">
            <path id="Vector_607" d="M71.3548 77.8381H69.1926V80.0003H71.3548V77.8381Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_1216">
          <g id="Group_1217">
            <path id="Vector_608" d="M73.5142 77.8381H71.3521V80.0003H73.5142V77.8381Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_1218">
          <g id="Group_1219">
            <path id="Vector_609" d="M75.6771 77.8378H73.5149V79.9999H75.6771V77.8378Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_1220">
          <g id="Group_1221">
            <path id="Vector_610" d="M77.8369 77.8381H75.6748V80.0003H77.8369V77.8381Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_1222">
          <g id="Group_1223">
            <path id="Vector_611" d="M80.0008 77.8378H77.8386V79.9999H80.0008V77.8378Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_1224">
          <g id="Group_1225">
            <g id="Group_1226">
              <path
                id="Subtract"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M2.27027 0H12.8649H15.1351V2.27027V12.8649V15.1351H12.8649H2.27027H0V12.8649V2.27027V0H2.27027ZM2.27027 12.8649H12.8649V12.8646H12.8669V2.27002H2.2723V2.27027H2.27027V12.8649Z"
                fill="#171D23"
              />
            </g>
          </g>
        </g>
        <g id="Group_1227">
          <g id="Group_1228">
            <g id="Group_1229">
              <path
                id="Subtract_2"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M67.1362 0H77.7308H80.0011V2.27027V12.8649V15.1351H77.7308H67.1362H64.866V12.8649V2.27027V0H67.1362ZM67.1362 12.8649H77.7308V12.8646H77.7329V2.27002H67.1383V2.27027H67.1362V12.8649Z"
                fill="#171D23"
              />
            </g>
          </g>
        </g>
        <g id="Group_1230">
          <g id="Group_1231">
            <g id="Group_1232">
              <path
                id="Subtract_3"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M2.27027 64.8648H12.8649H15.1351V67.1351V77.7297V79.9999H12.8649H2.27027H0V77.7297V67.1351V64.8648H2.27027ZM2.27027 77.7297H12.8649V77.7295H12.8669V67.1349H2.2723V67.1351H2.27027V77.7297Z"
                fill="#171D23"
              />
            </g>
          </g>
        </g>
        <g id="Group_1233">
          <g id="Group_1234">
            <path id="Vector_612" d="M10.8117 4.32483H4.3252V10.8113H10.8117V4.32483Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_1235">
          <g id="Group_1236">
            <path id="Vector_613" d="M75.6791 4.32483H69.1926V10.8113H75.6791V4.32483Z" fill="#171D23" />
          </g>
        </g>
        <g id="Group_1237">
          <g id="Group_1238">
            <path id="Vector_614" d="M10.8117 69.1886H4.3252V75.6751H10.8117V69.1886Z" fill="#171D23" />
          </g>
        </g>
      </g>
    </g>
    <defs>
      <clipPath id="clip0_3_53971">
        <rect width="80" height="80" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
